import {getValueByHash} from '#lit/utils/arrays.js';
import {AvatarColorVariants} from './index.js';

export function colorVariant(name: string): AvatarColorVariants {
  return getValueByHash<AvatarColorVariants>(
    Object.values(AvatarColorVariants),
    name
  );
}
